import { HelpMenuComponent } from './components/help-menu/help-menu.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TrendModule } from 'ngx-trend';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './containers/app.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarRightComponent } from './components/sidebar-right/sidebar-right.component';
import { TopMenuComponent } from './components/top-menu/top-menu.component';
// Removed ng2-slim-loading-bar-observables - using ngx-spinner instead
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { HttpClientModule } from '@angular/common/http';
import { GritterNotificationComponent } from './components/toast-notification/gritter-notification.component';
import { LinkyModule } from 'ngx-linky';
import { SharedModule } from '@lfx/shared/shared.module';
import { HelpSupportFrameComponent } from './components/help-support-frame/help-support-frame.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { UnauthorizedComponent } from './containers/unauthorized/unauthorized.component';
import { NotSupportedViewComponent } from './containers/not-supported-view/not-supported-view.component';
import { TrackEventDirective } from './directives/track-event.directive';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    NotFoundComponent,
    GritterNotificationComponent,
    HelpSupportFrameComponent,
    ForbiddenComponent,
    HelpMenuComponent,
    NotSupportedViewComponent,
    TrackEventDirective,
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    BrowserAnimationsModule,
    NgbModule,
    TrendModule,
    HttpClientModule,
    LinkyModule,
    HttpClientModule,
    NgSelectModule,
  ],
  exports: [
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    SidebarRightComponent,
    TopMenuComponent,
    UnauthorizedComponent,
    NotFoundComponent,
    GritterNotificationComponent,
    ForbiddenComponent,
    NotSupportedViewComponent,
    TrackEventDirective,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
